// extracted by mini-css-extract-plugin
export var connectionButton = "_as-1";
export var rightPanel = "_as-3";
export var stepDescription = "_as-2";
export var stepIcon = "_as-0";